import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ParseLinks {
  parse(header: string | null): Record<string, number> {
    if (!header) {
      return {};
    }

    const links: Record<string, number> = {};
    header.split(',').forEach(link => {
      const segments = link.split(';');
      if (segments.length < 2) {
        return;
      }

      const url = segments[0].trim().replace(/<(.*)>/, '$1');
      const rel = segments[1].trim().replace(/rel="(.*)"/, '$1');
      const pageMatch = /[?&]page=(\d+)/.exec(url);
      if (rel && pageMatch) {
        links[rel] = parseInt(pageMatch[1], 10);
      }
    });

    return links;
  }
}
